import { render, staticRenderFns } from "./featureAltComponent.vue?vue&type=template&id=648dd780&scoped=true&"
import script from "./featureAltComponent.vue?vue&type=script&lang=js&"
export * from "./featureAltComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648dd780",
  null
  
)

export default component.exports